function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOutlineWhiteSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Arrow-sm closed"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 804",
    style: {
      stroke: "#fff",
      strokeWidth: 2,
      fill: "none"
    },
    transform: "rotate(-90 20 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 13",
    transform: "rotate(-90 15.405 4.712)",
    style: {
      strokeLinecap: "round",
      stroke: "#fff",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0v18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2238.905 49.479 8.117 8.117 8.117-8.117",
    transform: "rotate(-90 1119.426 1147.713)",
    style: {
      strokeLinecap: "round",
      stroke: "#fff",
      strokeWidth: 2,
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOutlineWhiteSm);
export default __webpack_public_path__ + "static/media/Arrow-outline-white-sm.a3942727fa5ad871d1657a53817daaa5.svg";
export { ForwardRef as ReactComponent };